import {ServicesContainer} from '../containers/Documents/ServicesContainer'

export const Services = () => (
    <>
        <ServicesContainer />
    </>
)